
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.a789283082 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","epäluku",{".":",",",":" ","%":"%","+":"+","-":"−","E":"E","‰":"‰"},]);
Globalize.b1697586934 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","epäluku",{".":",",",":" ","%":"%","+":"+","-":"−","E":"E","‰":"‰"},]);
Globalize.a1549470730 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","epäluku",{".":",",",":" ","%":"%","+":"+","-":"−","E":"E","‰":"‰"},]);
Globalize.b1710360175 = numberParserFn([{",":"."," ":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^epäluku/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.a608441278 = pluralGeneratorFn(function(n
) {
  var s = String(n).split('.'), v0 = !s[1];
  return (n == 1 && v0) ? 'one' : 'other';
});
Globalize.a974784565 = messageFormatterFn((function(  ) {
  return function(d) { return "Matkat: lomia, halpoja lentoja, lentolippuja ja lentovarauksia"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1840590691 = messageFormatterFn((function(  ) {
  return function(d) { return "Pisteitä käytetty"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a917940870 = messageFormatterFn((function(  ) {
  return function(d) { return "Pisteitä ei käytetty"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2042118838 = messageFormatterFn((function(  ) {
  return function(d) { return "Sulje ponnahdusikkuna"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2020518771 = messageFormatterFn((function(  ) {
  return function(d) { return "Matkakohde"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1247322739 = messageFormatterFn((function(  ) {
  return function(d) { return "Tulopäivä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1240823138 = messageFormatterFn((function(  ) {
  return function(d) { return "Lähtöpäivä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1300169867 = messageFormatterFn((function(  ) {
  return function(d) { return "Päivä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a595498507 = messageFormatterFn((function(  ) {
  return function(d) { return "Asiakkaat"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a495284187 = messageFormatterFn((function(  ) {
  return function(d) { return "Hae"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a440043365 = messageFormatterFn((function(  ) {
  return function(d) { return "Lisätietoja: " + d["0"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a190416514 = messageFormatterFn((function(  ) {
  return function(d) { return "Avaa majoituspaikan " + d["0"] + " uudelle välilehdelle, palaa alkuperäiselle välilehdelle jatkaaksesi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b226546979 = messageFormatterFn((function(  ) {
  return function(d) { return "Hakutulokset"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b964379246 = messageFormatterFn((function(  ) {
  return function(d) { return "Valitse kohde"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1847355796 = messageFormatterFn((function(  ) {
  return function(d) { return "Valitse kelvollinen tulopäivä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1102027179 = messageFormatterFn((function(  ) {
  return function(d) { return "Valitse matkustuspäiväsi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1568366289 = messageFormatterFn((function(  ) {
  return function(d) { return "Lähtöpäivän on oltava tulopäivän jälkeen"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1133937383 = messageFormatterFn((function(  ) {
  return function(d) { return "Lähtöpäivän on oltava 28 päivän sisällä tulopäivästä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a674626467 = messageFormatterFn((function(  ) {
  return function(d) { return "Valitse kelvollinen lähtöpäivä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1185806993 = messageFormatterFn((function(  ) {
  return function(d) { return "Valitse asiakkaiden lukumäärä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b7613414 = messageFormatterFn((function(  ) {
  return function(d) { return "Anna lapsiasiakkaan ikä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1175938794 = messageFormatterFn((function(  ) {
  return function(d) { return "Anna lapsiasiakkaiden iät"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a710654472 = messageFormatterFn((function(  ) {
  return function(d) { return "Yöpymispäivien on oltava matkustuspäivien välisenä aikana"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b574958611 = messageFormatterFn((function(  ) {
  return function(d) { return "Valitse"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a769674175 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["0"]) + " huonetta";}, one: function() { return number(d["0"]) + " huone";}, two: function() { return number(d["0"]) + " huonetta";}, few: function() { return number(d["0"]) + " huonetta";}, many: function() { return number(d["0"]) + " huonetta";}, other: function() { return number(d["0"]) + " huonetta";} }) + ", " + plural(d["1"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["1"]) + " asiakasta";}, one: function() { return number(d["1"]) + " asiakas";}, two: function() { return number(d["1"]) + " asiakasta";}, few: function() { return number(d["1"]) + " asiakasta";}, many: function() { return number(d["1"]) + " asiakasta";}, other: function() { return number(d["1"]) + " asiakasta";} }); }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.a9050321 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["1"]) + " asiakasta";}, one: function() { return number(d["1"]) + " asiakas";}, two: function() { return number(d["1"]) + " asiakasta";}, few: function() { return number(d["1"]) + " asiakasta";}, many: function() { return number(d["1"]) + " asiakasta";}, other: function() { return number(d["1"]) + " asiakasta";} }); }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.a90142253 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["1"]) + " asiakasta";}, one: function() { return number(d["1"]) + " asiakas";}, two: function() { return number(d["1"]) + " asiakasta";}, few: function() { return number(d["1"]) + " asiakasta";}, many: function() { return number(d["1"]) + " asiakasta";}, other: function() { return number(d["1"]) + " asiakasta";} }) + ", lemmikkejä"; }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1238825804 = messageFormatterFn((function(  ) {
  return function(d) { return "Asiakkaat"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b560570496 = messageFormatterFn((function(  ) {
  return function(d) { return "Huone " + d["0"] + " lisätty. Muokkaa asiakkaiden tietoja alla."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1525873568 = messageFormatterFn((function(  ) {
  return function(d) { return "Huone poistettu. Muokkaa huoneen " + d["0"] + " asiakastietoja alla."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b237191428 = messageFormatterFn((function(  ) {
  return function(d) { return "Peruuta, sulje asiakasmäärän valintasivu tallentamatta muutoksia. Tai muokkaa asiakastietoja alla."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1972502596 = messageFormatterFn((function(  ) {
  return function(d) { return "Valmis"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b138084412 = messageFormatterFn((function(  ) {
  return function(d) { return "Tallenna muutokset ja sulje huonevalintasivu."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b116973912 = messageFormatterFn((function(  ) {
  return function(d) { return "Lisää toinen huone"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b556998727 = messageFormatterFn((function(  ) {
  return function(d) { return "Poista huone"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1099536705 = messageFormatterFn((function(  ) {
  return function(d) { return "Poista huone " + d["0"] + "/" + d["1"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a631399809 = messageFormatterFn((function(  ) {
  return function(d) { return "Lapsen " + d["0"] + " ikä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a909774823 = messageFormatterFn((function(  ) {
  return function(d) { return "Huone " + d["0"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1689375814 = messageFormatterFn((function(  ) {
  return function(d) { return "Huone " + d["0"] + "/" + d["1"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1062110600 = messageFormatterFn((function(  ) {
  return function(d) { return "Lapsi " + d["0"] + ", ikä " + d["1"] + " päivitetty."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a2126764702 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle 1-v."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1811386032 = messageFormatterFn((function(  ) {
  return function(d) { return "Lapsia"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a573971353 = messageFormatterFn((function(  ) {
  return function(d) { return "(0–17-v.)"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b623194726 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["0"]) + " aikuista";}, one: function() { return number(d["0"]) + " aikuinen";}, two: function() { return number(d["0"]) + " aikuista";}, few: function() { return number(d["0"]) + " aikuista";}, many: function() { return number(d["0"]) + " aikuista";}, other: function() { return number(d["0"]) + " aikuista";} }); }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.b818451808 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["0"]) + " lasta";}, one: function() { return number(d["0"]) + " lapsi";}, two: function() { return number(d["0"]) + " lasta";}, few: function() { return number(d["0"]) + " lasta";}, many: function() { return number(d["0"]) + " lasta";}, other: function() { return number(d["0"]) + " lasta";} }); }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.b533605450 = messageFormatterFn((function(  ) {
  return function(d) { return "Aikuisia"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1049044274 = messageFormatterFn((function(  ) {
  return function(d) { return "Vähennä lapsien lukumäärää huoneessa " + d["0"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b547806536 = messageFormatterFn((function(  ) {
  return function(d) { return "Vähennä aikuisten lukumäärää huoneessa " + d["0"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1815261966 = messageFormatterFn((function(  ) {
  return function(d) { return "Lisää lapsien lukumäärää huoneessa " + d["0"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1124497300 = messageFormatterFn((function(  ) {
  return function(d) { return "Lisää aikuisten lukumäärää huoneessa " + d["0"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1796105920 = messageFormatterFn((function(  ) {
  return function(d) { return "Lemmikkejä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b552059172 = messageFormatterFn((function(  ) {
  return function(d) { return "Sisältyykö varaukseen lemmikkejä?"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1159401552 = messageFormatterFn((function(  ) {
  return function(d) { return "Kyllä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a47518978 = messageFormatterFn((function(  ) {
  return function(d) { return "Ei"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1563765196 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " on tallennettu listoihisi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1560524346 = messageFormatterFn((function(  ) {
  return function(d) { return "Avautuu uuteen ikkunaan"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1229923675 = messageFormatterFn((function(  ) {
  return function(d) { return "Asiakasarvostelut"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a483679427 = messageFormatterFn((function(  ) {
  return function(d) { return "Peruuta, mene takaisin hotellin tietoihin."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1577430667 = messageFormatterFn((function(  ) {
  return function(d) { return "Tarkista saatavuus"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1136062304 = messageFormatterFn((function(  ) {
  return function(d) { return "Tarkista saatavuus"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a2139195118 = messageFormatterFn((function(  ) {
  return function(d) { return "Muuta hakua"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1910039121 = messageFormatterFn((function(  ) {
  return function(d) { return "Valitse myöhempi tulopäivä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b855605749 = messageFormatterFn((function(  ) {
  return function(d) { return "Valitse aikaisempi tulopäivä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1373580304 = messageFormatterFn((function(  ) {
  return function(d) { return "Valitse myöhempi lähtöpäivä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1866953620 = messageFormatterFn((function(  ) {
  return function(d) { return "Valitse aikaisempi lähtöpäivä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1353852774 = messageFormatterFn((function(  ) {
  return function(d) { return "Hinta oli " + d["0"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b495785452 = messageFormatterFn((function(  ) {
  return function(d) { return "Hinta on " + d["0"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1794084409 = messageFormatterFn((function(  ) {
  return function(d) { return "Hinta on nyt " + d["0"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a439529543 = messageFormatterFn((function(  ) {
  return function(d) { return "Hinta oli " + d["0"] + ". Hinta on nyt " + d["1"] + "."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2131434688 = messageFormatterFn((function(  ) {
  return function(d) { return "per yö"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1675659920 = messageFormatterFn((function(  ) {
  return function(d) { return "Peruuta, mene takaisin hotellin tietoihin."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1637727560 = messageFormatterFn((function(  ) {
  return function(d) { return "Lisätietoja"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1965580370 = messageFormatterFn((function(  ) {
  return function(d) { return "Sulje, mene takaisin hotellin tietoihin."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1693165444 = messageFormatterFn((function(  ) {
  return function(d) { return "Jokin meni vikaan."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1854807734 = messageFormatterFn((function(  ) {
  return function(d) { return "Yritä tehdä uusi haku."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1767672273 = messageFormatterFn((function(  ) {
  return function(d) { return "Saatat pitää myös näistä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1914876002 = messageFormatterFn((function(  ) {
  return function(d) { return "Sulje suodattimet"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a240465898 = messageFormatterFn((function(  ) {
  return function(d) { return "Lajittelu ja suodatus"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1279806412 = messageFormatterFn((function(  ) {
  return function(d) { return "Valmis"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b10301449 = messageFormatterFn((function(  ) {
  return function(d) { return "Tyhjennä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a750446734 = messageFormatterFn((function(  ) {
  return function(d) { return "Lisää suodattimet tai mene takaisin sulkeaksesi suodattimet"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1501190384 = messageFormatterFn((function(  ) {
  return function(d) { return "Vähimmäishinta"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1914619298 = messageFormatterFn((function(  ) {
  return function(d) { return "Korkein sallittu hinta"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1423178393 = messageFormatterFn((function(  ) {
  return function(d) { return "Tähtiluokitus"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1030925672 = messageFormatterFn((function(  ) {
  return function(d) { return "Lajitteluperuste"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b862772169 = messageFormatterFn((function(  ) {
  return function(d) { return "Suodatus"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a231876343 = messageFormatterFn((function(  ) {
  return function(d) { return "Takaisin hotellihakuun"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1841624211 = messageFormatterFn((function(  ) {
  return function(d) { return "Haetaan tuhansien majoituspaikkojen joukosta"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1238394968 = messageFormatterFn((function(  ) {
  return function(d) { return "Haetaan tuhansia pakettitarjouksia"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a315293660 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["0"]) + " suodatinta";}, one: function() { return number(d["0"]) + " suodatin";}, two: function() { return number(d["0"]) + " suodatinta";}, few: function() { return number(d["0"]) + " suodatinta";}, many: function() { return number(d["0"]) + " suodatinta";}, other: function() { return number(d["0"]) + " suodatinta";} }) + " käytössä"; }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1098680228 = messageFormatterFn((function(  ) {
  return function(d) { return "Lajittelu ja suodatus"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2075780624 = messageFormatterFn((function(  ) {
  return function(d) { return "Suodata"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1275500541 = messageFormatterFn((function(  ) {
  return function(d) { return "Kartta"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1284709914 = messageFormatterFn((function(  ) {
  return function(d) { return "tuloksia ladataan"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1499222203 = messageFormatterFn((function(  ) {
  return function(d) { return "tulokset päivitetty"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1197360629 = messageFormatterFn((function(  ) {
  return function(d) { return "virhe tuloksien hakemisessa"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2050382153 = messageFormatterFn((function(  ) {
  return function(d) { return "ei tuloksia"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2012813003 = messageFormatterFn((function(  ) {
  return function(d) { return "Hae hotelleja"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1418246148 = messageFormatterFn((function(  ) {
  return function(d) { return "Sulje"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b102372143 = messageFormatterFn((function(  ) {
  return function(d) { return "Valitse sen sijaan joku näistä päivistä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a918110357 = messageFormatterFn((function(  ) {
  return function(d) { return "Näytä lisää päiviä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a880289241 = messageFormatterFn((function(  ) {
  return function(d) { return "Näytä vähemmän päiviä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a668861718 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " – hakutulokset"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b790824393 = messageFormatterFn((function(  ) {
  return function(d) { return "Virheelliset hakutulokset"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1705099723 = messageFormatterFn((function(  ) {
  return function(d) { return "Näytä lisää"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1448618129 = messageFormatterFn((function(  ) {
  return function(d) { return "Emme valitettavasti löytäneet yhtään tulosta. Kokeile hakusi muokkaamista."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a228420039 = messageFormatterFn((function(  ) {
  return function(d) { return "Valittu suodatin"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1719507607 = messageFormatterFn((function(  ) {
  return function(d) { return "Valitut suodattimet"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b173515799 = messageFormatterFn((function(  ) {
  return function(d) { return "Matkakohde puuttuu"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1964809845 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "–" + d["1"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a2055868053 = messageFormatterFn((function(  ) {
  return function(d) { return "Poista kaikki suodattimet"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b421820332 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["0"]) + " asiakasta";}, one: function() { return number(d["0"]) + " asiakas";}, two: function() { return number(d["0"]) + " asiakasta";}, few: function() { return number(d["0"]) + " asiakasta";}, many: function() { return number(d["0"]) + " asiakasta";}, other: function() { return number(d["0"]) + " asiakasta";} }); }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.a175153644 = messageFormatterFn((function(  ) {
  return function(d) { return "Järjestelmässämme ilmeni valitettavasti ongelma"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1672195449 = messageFormatterFn((function(  ) {
  return function(d) { return "Yritä uudelleen"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b146877487 = messageFormatterFn((function(  ) {
  return function(d) { return "Tallenna " + d["0"] + " omille listoillesi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1761837127 = messageFormatterFn((function(  ) {
  return function(d) { return "Poista " + d["0"] + " omilta listoiltasi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1290783279 = messageFormatterFn((function(  ) {
  return function(d) { return "Seuraavan yöpymisesi tiedot"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1445787258 = messageFormatterFn((function(  ) {
  return function(d) { return "Hae tältä alueelta"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a633181164 = messageFormatterFn((function(  ) {
  return function(d) { return "Jokin meni valitettavasti vikaan. Yritä tehdä haku uudelleen."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1626234629 = messageFormatterFn((function(  ) {
  return function(d) { return "Sulje kartta"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b432529475 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["0"]) + " majoituspaikkaa";}, one: function() { return number(d["0"]) + " majoituspaikka";}, two: function() { return number(d["0"]) + " majoituspaikkaa";}, few: function() { return number(d["0"]) + " majoituspaikkaa";}, many: function() { return number(d["0"]) + " majoituspaikkaa";}, other: function() { return number(d["0"]) + " majoituspaikkaa";} }) + "\nalkaen " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1166031014 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["0"]) + " majoituspaikkaa";}, one: function() { return number(d["0"]) + " majoituspaikka";}, two: function() { return number(d["0"]) + " majoituspaikkaa";}, few: function() { return number(d["0"]) + " majoituspaikkaa";}, many: function() { return number(d["0"]) + " majoituspaikkaa";}, other: function() { return number(d["0"]) + " majoituspaikkaa";} }); }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1775871629 = messageFormatterFn((function(  ) {
  return function(d) { return "Näytä enemmän"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b556133344 = messageFormatterFn((function(  ) {
  return function(d) { return "Näytä vähemmän"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b61511182 = messageFormatterFn((function(  ) {
  return function(d) { return "Järjestelmässämme ilmeni valitettavasti ongelmia"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b28342978 = messageFormatterFn((function(  ) {
  return function(d) { return "Seuraava"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1346597950 = messageFormatterFn((function(  ) {
  return function(d) { return "Edellinen"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a800122085 = messageFormatterFn((function(  ) {
  return function(d) { return "Maksa"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a415648262 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Matkasi " + plural(d["0"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["0"]) + " huonetta";}, one: function() { return number(d["0"]) + " huone";}, two: function() { return number(d["0"]) + " huonetta";}, few: function() { return number(d["0"]) + " huonetta";}, many: function() { return number(d["0"]) + " huonetta";}, other: function() { return number(d["0"]) + " huonetta";} }); }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1830231023 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Matkasi (" + plural(d["0"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["0"]) + " majoitusta";}, one: function() { return number(d["0"]) + " majoitus";}, two: function() { return number(d["0"]) + " majoitusta";}, few: function() { return number(d["0"]) + " majoitusta";}, many: function() { return number(d["0"]) + " majoitusta";}, other: function() { return number(d["0"]) + " majoitusta";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.a224376267 = messageFormatterFn((function(  ) {
  return function(d) { return "Valitse seuraava hotellihuoneesi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a73909864 = messageFormatterFn((function(  ) {
  return function(d) { return "Ei enää saatavilla"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1682934412 = messageFormatterFn((function(  ) {
  return function(d) { return "Jotkut matkaasi kuuluvat majoituspaikat eivät ole enää saatavilla. Haluatko silti siirtyä maksamaan?"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a52683475 = messageFormatterFn((function(  ) {
  return function(d) { return "per huone"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1973406683 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["0"]) + " asiakasta";}, one: function() { return number(d["0"]) + " asiakas";}, two: function() { return number(d["0"]) + " asiakasta";}, few: function() { return number(d["0"]) + " asiakasta";}, many: function() { return number(d["0"]) + " asiakasta";}, other: function() { return number(d["0"]) + " asiakasta";} }); }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1498180097 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["0"]) + " huonetta";}, one: function() { return number(d["0"]) + " huone";}, two: function() { return number(d["0"]) + " huonetta";}, few: function() { return number(d["0"]) + " huonetta";}, many: function() { return number(d["0"]) + " huonetta";}, other: function() { return number(d["0"]) + " huonetta";} }) + ", " + plural(d["1"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["1"]) + " asiakasta";}, one: function() { return number(d["1"]) + " asiakas";}, two: function() { return number(d["1"]) + " asiakasta";}, few: function() { return number(d["1"]) + " asiakasta";}, many: function() { return number(d["1"]) + " asiakasta";}, other: function() { return number(d["1"]) + " asiakasta";} }); }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1447619724 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " / yö"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1417803348 = messageFormatterFn((function(  ) {
  return function(d) { return "Muuta huonetta"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1422496440 = messageFormatterFn((function(  ) {
  return function(d) { return "Koodi kopioitu leikepöydälle."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1821245279 = messageFormatterFn((function(  ) {
  return function(d) { return "Järjestelmässämme ilmeni valitettavasti ongelma"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a219450782 = messageFormatterFn((function(  ) {
  return function(d) { return "Yritä tehdä haku uudelleen"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1789244808 = messageFormatterFn((function(  ) {
  return function(d) { return "Yritä uudelleen"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1801635339 = messageFormatterFn((function(  ) {
  return function(d) { return "Vuokra-auton nouto ja palautus"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1149594988 = messageFormatterFn((function(  ) {
  return function(d) { return "Noutoaika"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a791321984 = messageFormatterFn((function(  ) {
  return function(d) { return "Palautusaika"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a198749727 = messageFormatterFn((function(  ) {
  return function(d) { return "Autonvuokraus"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1141482484 = messageFormatterFn((function(  ) {
  return function(d) { return "Palautusajan on oltava vähintään 2 tuntia noutoajan jälkeen"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1745666360 = messageFormatterFn((function(  ) {
  return function(d) { return "00.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1745755733 = messageFormatterFn((function(  ) {
  return function(d) { return "00.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1746589881 = messageFormatterFn((function(  ) {
  return function(d) { return "1.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1746679254 = messageFormatterFn((function(  ) {
  return function(d) { return "1.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1747513402 = messageFormatterFn((function(  ) {
  return function(d) { return "2.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1747602775 = messageFormatterFn((function(  ) {
  return function(d) { return "2.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1748436923 = messageFormatterFn((function(  ) {
  return function(d) { return "3.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1748526296 = messageFormatterFn((function(  ) {
  return function(d) { return "3.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1749360444 = messageFormatterFn((function(  ) {
  return function(d) { return "4.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1749449817 = messageFormatterFn((function(  ) {
  return function(d) { return "4.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1750283965 = messageFormatterFn((function(  ) {
  return function(d) { return "5.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1750373338 = messageFormatterFn((function(  ) {
  return function(d) { return "5.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1751207486 = messageFormatterFn((function(  ) {
  return function(d) { return "6.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1751296859 = messageFormatterFn((function(  ) {
  return function(d) { return "6.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1752131007 = messageFormatterFn((function(  ) {
  return function(d) { return "7.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1752220380 = messageFormatterFn((function(  ) {
  return function(d) { return "7.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1753054528 = messageFormatterFn((function(  ) {
  return function(d) { return "8.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1753143901 = messageFormatterFn((function(  ) {
  return function(d) { return "8.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1753978049 = messageFormatterFn((function(  ) {
  return function(d) { return "9.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1754067422 = messageFormatterFn((function(  ) {
  return function(d) { return "9.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1774295511 = messageFormatterFn((function(  ) {
  return function(d) { return "10.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1774384884 = messageFormatterFn((function(  ) {
  return function(d) { return "10.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1775219032 = messageFormatterFn((function(  ) {
  return function(d) { return "11.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1775308405 = messageFormatterFn((function(  ) {
  return function(d) { return "11.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1776142553 = messageFormatterFn((function(  ) {
  return function(d) { return "12.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1776231926 = messageFormatterFn((function(  ) {
  return function(d) { return "12.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1777066074 = messageFormatterFn((function(  ) {
  return function(d) { return "13.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1777155447 = messageFormatterFn((function(  ) {
  return function(d) { return "13.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1777989595 = messageFormatterFn((function(  ) {
  return function(d) { return "14.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1778078968 = messageFormatterFn((function(  ) {
  return function(d) { return "14.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1778913116 = messageFormatterFn((function(  ) {
  return function(d) { return "15.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1779002489 = messageFormatterFn((function(  ) {
  return function(d) { return "15.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1779836637 = messageFormatterFn((function(  ) {
  return function(d) { return "16.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1779926010 = messageFormatterFn((function(  ) {
  return function(d) { return "16.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1780760158 = messageFormatterFn((function(  ) {
  return function(d) { return "17.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1780849531 = messageFormatterFn((function(  ) {
  return function(d) { return "17.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1781683679 = messageFormatterFn((function(  ) {
  return function(d) { return "18.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1781773052 = messageFormatterFn((function(  ) {
  return function(d) { return "18.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1782607200 = messageFormatterFn((function(  ) {
  return function(d) { return "19.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1782696573 = messageFormatterFn((function(  ) {
  return function(d) { return "19.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1802924662 = messageFormatterFn((function(  ) {
  return function(d) { return "20.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1803014035 = messageFormatterFn((function(  ) {
  return function(d) { return "20.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1803848183 = messageFormatterFn((function(  ) {
  return function(d) { return "21.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1803937556 = messageFormatterFn((function(  ) {
  return function(d) { return "21.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1804771704 = messageFormatterFn((function(  ) {
  return function(d) { return "22.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1804861077 = messageFormatterFn((function(  ) {
  return function(d) { return "22.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1805695225 = messageFormatterFn((function(  ) {
  return function(d) { return "23.00"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1805784598 = messageFormatterFn((function(  ) {
  return function(d) { return "23.30"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1313903353 = messageFormatterFn((function(  ) {
  return function(d) { return "Vain suorat lennot"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2065010892 = messageFormatterFn((function(  ) {
  return function(d) { return "Toivottu luokka"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a938852020 = messageFormatterFn((function(  ) {
  return function(d) { return "Economy"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1583808045 = messageFormatterFn((function(  ) {
  return function(d) { return "Premium Economy"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b71404308 = messageFormatterFn((function(  ) {
  return function(d) { return "Business"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a514679572 = messageFormatterFn((function(  ) {
  return function(d) { return "1. luokka"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1510258709 = messageFormatterFn((function(  ) {
  return function(d) { return "Matkustajat"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1393714057 = messageFormatterFn((function(  ) {
  return function(d) { return "Jokaista sylissä matkustavaa vauvaa kohden tulee olla ainakin 1 matkustaja (väh. 6-vuotias)."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a382014898 = messageFormatterFn((function(  ) {
  return function(d) { return "Vauvoja"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b321249221 = messageFormatterFn((function(  ) {
  return function(d) { return "(2–17-v.)"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1515709097 = messageFormatterFn((function(  ) {
  return function(d) { return "Ikä alle 2 vuotta"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1671633947 = messageFormatterFn((function(  ) {
  return function(d) { return "Vauvan " + d["0"] + " ikä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1548396703 = messageFormatterFn((function(  ) {
  return function(d) { return "Vähennä vauvojen lukumäärää huoneessa " + d["0"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a623344189 = messageFormatterFn((function(  ) {
  return function(d) { return "Lisää vauvojen lukumäärää huoneessa " + d["0"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b587603761 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle 2-vuotiaiden lasten tulee istua joko sylissä tai istuinpaikalla"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1152989495 = messageFormatterFn((function(  ) {
  return function(d) { return "Sylissä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a834627275 = messageFormatterFn((function(  ) {
  return function(d) { return "Istuinpaikalla"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a369451828 = messageFormatterFn((function(  ) {
  return function(d) { return "Lentoyhtiön ikäsäännöt"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1601827520 = messageFormatterFn((function(  ) {
  return function(d) { return "Lähtöpaikka"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b225939640 = messageFormatterFn((function(  ) {
  return function(d) { return "Lähtö"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b187037308 = messageFormatterFn((function(  ) {
  return function(d) { return "Paluu"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1358780638 = messageFormatterFn((function(  ) {
  return function(d) { return "Valitse lähtöpaikka"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1733924604 = messageFormatterFn((function(  ) {
  return function(d) { return "Tarvitsen majoituksen vain osaksi matkani kestoa"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a908009923 = messageFormatterFn((function(  ) {
  return function(d) { return "Jokin järjestelmässämme meni valitettavasti vikaan. Ole hyvä ja yritä uudelleen."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1540927409 = messageFormatterFn((function(  ) {
  return function(d) { return "Valitse vähintään 1 majoituspaikka lisää vertailtavaksi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1215089166 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + " / " + plural(d["1"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["1"]) + " majoituspaikkaa";}, one: function() { return number(d["1"]) + " majoituspaikkaa";}, two: function() { return number(d["1"]) + " majoituspaikkaa";}, few: function() { return number(d["1"]) + " majoituspaikkaa";}, many: function() { return number(d["1"]) + " majoituspaikkaa";}, other: function() { return number(d["1"]) + " majoituspaikkaa";} }) + " valittu"; }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1635554454 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + " kautta " + plural(d["1"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["1"]) + " majoituspaikkaa";}, one: function() { return number(d["1"]) + " majoituspaikkaa";}, two: function() { return number(d["1"]) + " majoituspaikkaa";}, few: function() { return number(d["1"]) + " majoituspaikkaa";}, many: function() { return number(d["1"]) + " majoituspaikkaa";}, other: function() { return number(d["1"]) + " majoituspaikkaa";} }) + " valittu"; }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.b397566984 = messageFormatterFn((function(  ) {
  return function(d) { return "Vertaa"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b359278300 = messageFormatterFn((function(  ) {
  return function(d) { return "Vertaile valittuja majoituspaikkoja"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1214673346 = messageFormatterFn((function(  ) {
  return function(d) { return "Vertaa"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1583637150 = messageFormatterFn((function(  ) {
  return function(d) { return "Vertaile valittuja majoituspaikkoja"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1267872368 = messageFormatterFn((function(  ) {
  return function(d) { return "Tarkastele"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1397548684 = messageFormatterFn((function(  ) {
  return function(d) { return "Napsauta tarkastellaksesi majoituspaikkaa"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b361798737 = messageFormatterFn((function(  ) {
  return function(d) { return "Poista"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b507556915 = messageFormatterFn((function(  ) {
  return function(d) { return "Napsauta poistaaksesi majoituspaikan vertailusta"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a2061970242 = messageFormatterFn((function(  ) {
  return function(d) { return "Sulje"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1719373946 = messageFormatterFn((function(  ) {
  return function(d) { return "Peruuta"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2078037100 = messageFormatterFn((function(  ) {
  return function(d) { return "Ohita"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1067700942 = messageFormatterFn((function(  ) {
  return function(d) { return "Valmis"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2109022448 = messageFormatterFn((function(  ) {
  return function(d) { return "Poista"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1996435239 = messageFormatterFn((function(  ) {
  return function(d) { return "valittu"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b838863418 = messageFormatterFn((function(  ) {
  return function(d) { return "Ladataan."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a2052211287 = messageFormatterFn((function(  ) {
  return function(d) { return "Poista"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b217125585 = messageFormatterFn((function(  ) {
  return function(d) { return "Avautuu uuteen ikkunaan"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b959969813 = messageFormatterFn((function(  ) {
  return function(d) { return "Näytä enemmän"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1314099208 = messageFormatterFn((function(  ) {
  return function(d) { return "Näytä vähemmän"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1478099692 = messageFormatterFn((function(  ) {
  return function(d) { return "Näytä enemmän"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a913518777 = messageFormatterFn((function(  ) {
  return function(d) { return "Näytä vähemmän"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a265493458 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " valittu. Valitse seuraavaksi lähtöpäivä."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a522350591 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " valittu. Valitse valmis tallentaaksesi nämä päivät ja sulkeaksesi kalenterin."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1154973981 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", tämänhetkinen tulopäivä."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b702428642 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", tämänhetkinen lähtöpäivä."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b88423564 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", päivä ei käytössä."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b688306127 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", tämänhetkinen kuukausi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b359685932 = messageFormatterFn((function(  ) {
  return function(d) { return "Näytetään vaihtoehtoa " + d["0"] + " ja " + d["1"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a467669784 = messageFormatterFn((function(  ) {
  return function(d) { return "Kalenteri avattu. Valitse päivä alla olevasta taulukosta."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a2139016822 = messageFormatterFn((function(  ) {
  return function(d) { return "Peruuta, sulje kalenteri tallentamatta muutoksia. Tai valitse päivä alla olevasta taulukosta."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b112354278 = messageFormatterFn((function(  ) {
  return function(d) { return "Poista valitut päivämäärät."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1445503345 = messageFormatterFn((function(  ) {
  return function(d) { return "Tallenna muutokset ja sulje kalenteri."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a811359434 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["0"]) + " yötä";}, one: function() { return number(d["0"]) + " yö";}, two: function() { return number(d["0"]) + " yötä";}, few: function() { return number(d["0"]) + " yötä";}, many: function() { return number(d["0"]) + " yötä";}, other: function() { return number(d["0"]) + " yötä";} }); }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.a309730330 = messageFormatterFn((function(  ) {
  return function(d) { return "Tulopäivä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1192932779 = messageFormatterFn((function(  ) {
  return function(d) { return "Lähtöpäivä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1085757876 = messageFormatterFn((function(  ) {
  return function(d) { return "Poista päivämäärät"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1252135669 = messageFormatterFn((function(  ) {
  return function(d) { return "Valmis"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1963607281 = messageFormatterFn((function(  ) {
  return function(d) { return "Hae"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b386639385 = messageFormatterFn((function(  ) {
  return function(d) { return "Muokkaa tulopäivää alla olevassa taulukossa."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1954696840 = messageFormatterFn((function(  ) {
  return function(d) { return "Muokkaa lähtöpäivää alla olevassa taulukossa."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1615421945 = messageFormatterFn((function(  ) {
  return function(d) { return "valittu."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1201458284 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " valittu. Sulje kalenteri tai muuta valittua päivää."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1032594588 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " viiva " + d["1"] + " valittu. Sulje kalenteri tai muuta valittuja päiviä."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1128415458 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " valittu. " + d["1"] + ". Sulje kalenteri tai muuta valittua päivää."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1931667862 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " viiva " + d["1"] + " valittu. " + d["2"] + ". Sulje kalenteri tai muuta valittuja päiviä."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1351123645 = messageFormatterFn((function(  ) {
  return function(d) { return "Valitse tulopäivä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a171248182 = messageFormatterFn((function(  ) {
  return function(d) { return "Valitse lähtöpäivä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b735827419 = messageFormatterFn((function(  ) {
  return function(d) { return "tyhjä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1254207683 = messageFormatterFn((function(  ) {
  return function(d) { return "Edellinen kuukausi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1567860903 = messageFormatterFn((function(  ) {
  return function(d) { return "Seuraava kuukausi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b572503800 = messageFormatterFn((function(  ) {
  return function(d) { return "Siirry painikkeeseen " + d["0"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b453310752 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " viiva " + d["1"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a546839069 = messageFormatterFn((function(  ) {
  return function(d) { return "Päivämäärät on poistettu"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1600040560 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["0"]) + " tulosta";}, one: function() { return number(d["0"]) + " tulos";}, two: function() { return number(d["0"]) + " tulosta";}, few: function() { return number(d["0"]) + " tulosta";}, many: function() { return number(d["0"]) + " tulosta";}, other: function() { return number(d["0"]) + " tulosta";} }); }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1411520889 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "“" + d["0"] + "” tuotti " + plural(d["1"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["1"]) + " tulosta";}, one: function() { return number(d["1"]) + " tulosta";}, two: function() { return number(d["1"]) + " tulosta";}, few: function() { return number(d["1"]) + " tulosta";}, many: function() { return number(d["1"]) + " tulosta";}, other: function() { return number(d["1"]) + " tulosta";} }) + ". Käytä nuolinäppäimiä tai pyyhkäise selataksesi listaa."; }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1753809555 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " -haku avoinna. Anna hakusana."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b65168478 = messageFormatterFn((function(  ) {
  return function(d) { return "Valitsit paikan " + d["0"] + "."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a2102201215 = messageFormatterFn((function(  ) {
  return function(d) { return "Valikko on suljettu."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b35513787 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Haku " + d["0"] + " on auki, näytetään " + plural(d["1"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["1"]) + " ehdotusta";}, one: function() { return number(d["1"]) + " ehdotus";}, two: function() { return number(d["1"]) + " ehdotusta";}, few: function() { return number(d["1"]) + " ehdotusta";}, many: function() { return number(d["1"]) + " ehdotusta";}, other: function() { return number(d["1"]) + " ehdotusta";} }) + " haulle " + d["2"] + ". Siirry alla olevaan listaan."; }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1910300334 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Haku " + d["0"] + " on auki, näytetään " + plural(d["1"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["1"]) + " ehdotusta";}, one: function() { return number(d["1"]) + " ehdotus";}, two: function() { return number(d["1"]) + " ehdotusta";}, few: function() { return number(d["1"]) + " ehdotusta";}, many: function() { return number(d["1"]) + " ehdotusta";}, other: function() { return number(d["1"]) + " ehdotusta";} }) + ". Anna hakutermi tai siirry alla olevaan listaan."; }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1530446706 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Haku " + d["0"] + " on auki, " + d["1"] + " tällä hetkellä valittuna, näytetään " + plural(d["1"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["1"]) + " ehdotusta";}, one: function() { return number(d["1"]) + " ehdotus";}, two: function() { return number(d["1"]) + " ehdotusta";}, few: function() { return number(d["1"]) + " ehdotusta";}, many: function() { return number(d["1"]) + " ehdotusta";}, other: function() { return number(d["1"]) + " ehdotusta";} }) + " haulle " + d["3"] + ". Siirry alla olevaan listaan."; }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1540363468 = messageFormatterFn((function(  ) {
  return function(d) { return "Valmis"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1662066069 = messageFormatterFn((function(  ) {
  return function(d) { return "Poista kaikki"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1056253310 = messageFormatterFn((function(  ) {
  return function(d) { return "Valitut vaihtoehdot"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1940825653 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " poistettu."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1803592082 = messageFormatterFn((function(  ) {
  return function(d) { return "Kaikki valinnat poistettu."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b491183037 = messageFormatterFn((function(  ) {
  return function(d) { return "Olet kirjoittanut tekstikenttään. Hae tai valitse alla ehdotettujen kategorioiden joukosta."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1042995676 = messageFormatterFn((function(  ) {
  return function(d) { return "Hae ”" + d["0"] + "”"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1750364387 = messageFormatterFn((function(  ) {
  return function(d) { return "Ei tuloksia haulle ”" + d["0"] + "”"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b999897607 = messageFormatterFn((function(  ) {
  return function(d) { return "Lentokenttä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1910188702 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotelli"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b812488392 = messageFormatterFn((function(  ) {
  return function(d) { return "Mielenkiintoinen kohde"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1814372897 = messageFormatterFn((function(  ) {
  return function(d) { return "Lähistöllä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b993001122 = messageFormatterFn((function(  ) {
  return function(d) { return "Esim. ”" + d["0"] + "”"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1915088583 = messageFormatterFn((function(  ) {
  return function(d) { return "Alue/kaupunki"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b287495355 = messageFormatterFn((function(  ) {
  return function(d) { return "Lentokenttä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1899878141 = messageFormatterFn((function(  ) {
  return function(d) { return "Nähtävyys"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b447996498 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotelli"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a96289838 = messageFormatterFn((function(  ) {
  return function(d) { return "Osoite"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2085007832 = messageFormatterFn((function(  ) {
  return function(d) { return "Rautatieasema"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b58427849 = messageFormatterFn((function(  ) {
  return function(d) { return "Metroasema"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a46671515 = messageFormatterFn((function(  ) {
  return function(d) { return "Tutustu lähistön kohteisiin"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a947250382 = messageFormatterFn((function(  ) {
  return function(d) { return "Viimeaikaiset haut"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b772756620 = messageFormatterFn((function(  ) {
  return function(d) { return "Muut matkailijat hakivat myös näitä:"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2128483455 = messageFormatterFn((function(  ) {
  return function(d) { return "Tutustu nousussa oleviin kohteisiin"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1397721645 = messageFormatterFn((function(  ) {
  return function(d) { return "Suosittuja kohteita"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1710223671 = messageFormatterFn((function(  ) {
  return function(d) { return "Nousussa olevia kohteita"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1341161547 = messageFormatterFn((function(  ) {
  return function(d) { return "Tämänhetkinen sijainti"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b519325240 = messageFormatterFn((function(  ) {
  return function(d) { return "Sijainnin jakaminen on poissa päältä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a12243336 = messageFormatterFn((function(  ) {
  return function(d) { return "Sijaintisi määrittäminen ei onnistu. Ota laitteesi sijaintipalvelut käyttöön, jotta voimme määrittää sijaintisi, tai kirjoita kohteesi."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1889539556 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["0"]) + " huonetta";}, one: function() { return number(d["0"]) + " huone";}, two: function() { return number(d["0"]) + " huonetta";}, few: function() { return number(d["0"]) + " huonetta";}, many: function() { return number(d["0"]) + " huonetta";}, other: function() { return number(d["0"]) + " huonetta";} }) + ", " + plural(d["1"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["1"]) + " asiakasta";}, one: function() { return number(d["1"]) + " asiakas";}, two: function() { return number(d["1"]) + " asiakasta";}, few: function() { return number(d["1"]) + " asiakasta";}, many: function() { return number(d["1"]) + " asiakasta";}, other: function() { return number(d["1"]) + " asiakasta";} }); }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1845880554 = messageFormatterFn((function(  ) {
  return function(d) { return "Kentän " + d["0"] + " arvo on nyt " + d["1"] + ". Kentän " + d["2"] + " arvo on nyt " + d["3"] + "."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1145503783 = messageFormatterFn((function(  ) {
  return function(d) { return "Vaihda kentät " + d["0"] + " ja " + d["1"] + "."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b316566854 = messageFormatterFn((function(  ) {
  return function(d) { return "Näytä salasana"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b630908993 = messageFormatterFn((function(  ) {
  return function(d) { return "Piilota salasana"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a295113144 = messageFormatterFn((function(  ) {
  return function(d) { return "Näytetään vaihtoehtoa " + d["0"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b933387299 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " kautta " + d["1"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a2144911865 = messageFormatterFn((function(  ) {
  return function(d) { return "Kuva " + d["0"] + " kautta " + d["1"] + ". " + d["2"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a371471542 = messageFormatterFn((function(  ) {
  return function(d) { return "Avaa seuraava kuva"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2099743054 = messageFormatterFn((function(  ) {
  return function(d) { return "Avaa edellinen kuva"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b188256920 = messageFormatterFn((function(  ) {
  return function(d) { return "Avaa kaikki " + d["0"] + " kuvaa"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1299388147 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Näytä " + plural(d["0"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["0"]) + " kuvaa";}, one: function() { return number(d["0"]) + " kuva";}, two: function() { return number(d["0"]) + " kuvaa";}, few: function() { return number(d["0"]) + " kuvaa";}, many: function() { return number(d["0"]) + " kuvaa";}, other: function() { return number(d["0"]) + " kuvaa";} }) + " huoneesta " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.a548183114 = messageFormatterFn((function(  ) {
  return function(d) { return "Suoritettu vaihe:"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1913622776 = messageFormatterFn((function(  ) {
  return function(d) { return "Nykyinen vaihe:"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1735822298 = messageFormatterFn((function(  ) {
  return function(d) { return "Vaihe " + d["0"] + "/" + d["1"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a209710518 = messageFormatterFn((function(  ) {
  return function(d) { return "Vaihe " + d["0"] + " kautta " + d["1"] + ":"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b301023113 = messageFormatterFn((function(  ) {
  return function(d) { return "Kuva " + d["0"] + " kautta " + d["1"] + ". " + d["2"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2044478796 = messageFormatterFn((function(  ) {
  return function(d) { return "Seuraava kuva"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a998821296 = messageFormatterFn((function(  ) {
  return function(d) { return "Edellinen kuva"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1192652162 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", laajenna koko näytölle"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b577922474 = messageFormatterFn((function(  ) {
  return function(d) { return "Esikatselukuva " + d["0"] + ", laajenna koko näytölle"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a2051193492 = messageFormatterFn((function(  ) {
  return function(d) { return "Tämänhetkinen sivu"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2125463268 = messageFormatterFn((function(  ) {
  return function(d) { return "Näytä lisää linkkipolkuja"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a2131682912 = messageFormatterFn((function(  ) {
  return function(d) { return "Näytä vähemmän linkkipolkuja"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a823879299 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " prosenttia, ladataan"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b779960002 = messageFormatterFn((function(  ) {
  return function(d) { return "Ladataan"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1351140430 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " " + d["1"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1748054263 = messageFormatterFn((function(  ) {
  return function(d) { return "Tapahtui virhe."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b388999379 = messageFormatterFn((function(  ) {
  return function(d) { return "Katso tämä video osoitteessa www.youtube.com tai salli JavaScriptin käyttö selaimessasi, jos se on pois päältä."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a350541163 = messageFormatterFn((function(  ) {
  return function(d) { return "Toista video"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1526056549 = messageFormatterFn((function(  ) {
  return function(d) { return "Pysäytä video"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b583937219 = messageFormatterFn((function(  ) {
  return function(d) { return "Video latautuu"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1230303923 = messageFormatterFn((function(  ) {
  return function(d) { return "360 asteen kuva"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a546157715 = messageFormatterFn((function(  ) {
  return function(d) { return "Tämä on 360 asteen kuva. Käytä Control- ja nuolinäppäimiä tai Komento- ja nuolinäppäimiä siirtyäksesi kuvan eri kohtiin."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a533447104 = messageFormatterFn((function(  ) {
  return function(d) { return "Näytetään kuvaa: " + d["0"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b173048481 = messageFormatterFn((function(  ) {
  return function(d) { return "Siirrytty vasemmalle. Sijainti: " + d["0"] + " astetta"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a75678874 = messageFormatterFn((function(  ) {
  return function(d) { return "Siirrytty oikealle. Sijainti: " + d["0"] + " astetta"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a71604787 = messageFormatterFn((function(  ) {
  return function(d) { return "Siirrytty ylöspäin"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b392345798 = messageFormatterFn((function(  ) {
  return function(d) { return "Siirrytty alaspäin"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b92617419 = messageFormatterFn((function(  ) {
  return function(d) { return "Olet ylälaidassa"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1383514401 = messageFormatterFn((function(  ) {
  return function(d) { return "Olet alalaidassa"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b844992651 = messageFormatterFn((function(  ) {
  return function(d) { return "Valitse kaikki rivit"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a655994068 = messageFormatterFn((function(  ) {
  return function(d) { return "Poista kaikkien rivien valinta"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1456478436 = messageFormatterFn((function(  ) {
  return function(d) { return "Järjestä sarake laskevaan järjestykseen"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a540603330 = messageFormatterFn((function(  ) {
  return function(d) { return "Järjestä sarake nousevaan järjestykseen"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1403739922 = messageFormatterFn((function(  ) {
  return function(d) { return "Sarake on nyt laskevassa järjestyksessä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a2116942166 = messageFormatterFn((function(  ) {
  return function(d) { return "Sarake on nyt nousevassa järjestyksessä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b454639758 = messageFormatterFn((function(  ) {
  return function(d) { return "Laajenna riviä " + d["0"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1377750479 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Näytetään " + d["0"] + " tuotetta, yhteensä " + plural(d["1"], 0, pluralFuncs["fi-FI"], { zero: function() { return number(d["1"]) + " tuotetta";}, one: function() { return number(d["1"]) + " tuote";}, two: function() { return number(d["1"]) + " tuotetta";}, few: function() { return number(d["1"]) + " tuotetta";}, many: function() { return number(d["1"]) + " tuotetta";}, other: function() { return number(d["1"]) + " tuotetta";} }); }
})(messageFormat.number, messageFormat.plural, {"fi-FI": Globalize("fi-FI").pluralGenerator()}), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1864384415 = messageFormatterFn((function(  ) {
  return function(d) { return "tämänhetkiset kuukautesi ovat " + d["0"] + " " + d["1"] + " ja " + d["2"] + " " + d["3"] + "."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a2088976199 = messageFormatterFn((function(  ) {
  return function(d) { return "Tulopäivä poistettu."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b74466448 = messageFormatterFn((function(  ) {
  return function(d) { return "Lähtöpäivä poistettu."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1517965905 = messageFormatterFn((function(  ) {
  return function(d) { return "Päivämäärät poistettu."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1819683597 = messageFormatterFn((function(  ) {
  return function(d) { return "Seuraava"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2020085171 = messageFormatterFn((function(  ) {
  return function(d) { return "Edellinen"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1742573266 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " on valittu tulopäiväksesi."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b899639351 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " on valittu lähtöpäiväksesi."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b77293074 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ei ole kelvollinen tulopäivä."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1975087593 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ei ole kelvollinen lähtöpäivä."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2099119686 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ei ole saatavilla."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1696023573 = messageFormatterFn((function(  ) {
  return function(d) { return "Tänään"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b404547244 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " kautta " + d["1"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a10481258 = messageFormatterFn((function(  ) {
  return function(d) { return "Kirjaudu sisään " + d["0"] + "-sivustolle"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b316704989 = messageFormatterFn((function(  ) {
  return function(d) { return "Tervetuloa takaisin! Kirjaudu sisään jollain seuraavista"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b661713705 = messageFormatterFn((function(  ) {
  return function(d) { return "Tervetuloa takaisin! Kirjaudu sisään ja säästä jäsenhinnoilla vähintään 10 % tuhansista majoituspaikoista."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b737698237 = messageFormatterFn((function(  ) {
  return function(d) { return "Sähköpostiosoite"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a610115498 = messageFormatterFn((function(  ) {
  return function(d) { return "Salasana"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1890130329 = messageFormatterFn((function(  ) {
  return function(d) { return "Tarvitsetko tilin?"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1204088181 = messageFormatterFn((function(  ) {
  return function(d) { return "Kirjaudutaan sisään"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a432012808 = messageFormatterFn((function(  ) {
  return function(d) { return "Kirjaudu sisään Facebookin avulla"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a900601467 = messageFormatterFn((function(  ) {
  return function(d) { return "Kirjaudu sisään Googlen avulla"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b681523115 = messageFormatterFn((function(  ) {
  return function(d) { return "Pidä minut sisäänkirjautuneena"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a813247086 = messageFormatterFn((function(  ) {
  return function(d) { return "Pidä minut sisäänkirjautuneena (sivusto käyttää evästeitä)"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b840585436 = messageFormatterFn((function(  ) {
  return function(d) { return "Kirjaudu sisään"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b840226022 = messageFormatterFn((function(  ) {
  return function(d) { return "Liity"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2100370890 = messageFormatterFn((function(  ) {
  return function(d) { return "<a href=\"" + d["0"] + "\">Kirjaudu sisään Facebookin kautta</a>"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1492532160 = messageFormatterFn((function(  ) {
  return function(d) { return "Unohditko salasanan?"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1904090541 = messageFormatterFn((function(  ) {
  return function(d) { return "Anna sähköpostiosoite"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1797123031 = messageFormatterFn((function(  ) {
  return function(d) { return "Anna kelvollinen sähköpostiosoite."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1097588326 = messageFormatterFn((function(  ) {
  return function(d) { return "Anna salasana"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1559579168 = messageFormatterFn((function(  ) {
  return function(d) { return "Ole hyvä ja yritä uudelleen"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a534916708 = messageFormatterFn((function(  ) {
  return function(d) { return "Hupsista, jokin meni vikaan"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2059372734 = messageFormatterFn((function(  ) {
  return function(d) { return "Korjaa alla oleva virhe jatkaaksesi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a110011289 = messageFormatterFn((function(  ) {
  return function(d) { return "Korjaa alla olevat 2 virhettä jatkaaksesi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1216983343 = messageFormatterFn((function(  ) {
  return function(d) { return "Kirjaudu sisään sähköpostiosoitteella"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1377308898 = messageFormatterFn((function(  ) {
  return function(d) { return "Voit myös kirjautua sisään sähköpostiosoitteella"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1971783719 = messageFormatterFn((function(  ) {
  return function(d) { return "Sähköpostiosoite"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b938181178 = messageFormatterFn((function(  ) {
  return function(d) { return "tai"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b21466616 = messageFormatterFn((function(  ) {
  return function(d) { return "Unohditko salasanan?"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b484312651 = messageFormatterFn((function(  ) {
  return function(d) { return "Etkö ole jäsen?"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1723388159 = messageFormatterFn((function(  ) {
  return function(d) { return "Luo tili"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1854943152 = messageFormatterFn((function(  ) {
  return function(d) { return "Kirjautumalla sisään hyväksyn <a href=\"" + d["0"] + "\" target=\"_blank\">" + d["1"] + " -ohjelman ehdot ja rajoitukset. <span class=\"is-visually-hidden\">Avautuu uuteen ikkunaan</span></a>"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1970047430 = messageFormatterFn((function(  ) {
  return function(d) { return "Kirjautumalla sisään " + d["0"] + "-tililleni hyväksyn <a href=\"" + d["1"] + "\" target=\"_blank\">" + d["2"] + " käyttöehdot<span class=\"is-visually-hidden\">avautuu uuteen ikkunaan</span></a>, <a href=\"" + d["3"] + "\" target=\"_blank\">tietosuojakäytännön<span class=\"is-visually-hidden\">avautuu uuteen ikkunaan</span></a> ja <a href=\"" + d["4"] + "\" target=\"_blank\">" + d["5"] + " -ohjelman ehdot ja rajoitukset<span class=\"is-visually-hidden\">avautuu uuteen ikkunaan</span></a>. "; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b974998678 = messageFormatterFn((function(  ) {
  return function(d) { return "Liity <a href=\"" + d["0"] + "\" target=\"_blank\">" + d["1"] + " -ohjelmaan. <span class=\"is-visually-hidden\">Avautuu uuteen ikkunaan</span></a> Liittymällä ohjelmaan hyväksyn kaikki <a href=\"" + d["3"] + "\" target=\"_blank\">ehdot ja rajoitukset. <span class=\"is-visually-hidden\">Avautuu uuteen ikkunaan</span></a>"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a846982150 = messageFormatterFn((function(  ) {
  return function(d) { return "Ehtoja sovelletaan, linkki sivun alalaidassa"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2126788596 = messageFormatterFn((function(  ) {
  return function(d) { return "Tarkista sähköpostisi!"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a594167481 = messageFormatterFn((function(  ) {
  return function(d) { return "Vaihda salasanasi osoitteeseen " + d["0"] + " lähettämämme linkin avulla"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a368521798 = messageFormatterFn((function(  ) {
  return function(d) { return "Lähetä linkki uudelleen"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b902759322 = messageFormatterFn((function(  ) {
  return function(d) { return "Järjestelmässämme tapahtui virhe"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1552482145 = messageFormatterFn((function(  ) {
  return function(d) { return "Yritä uudelleen."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b999819014 = messageFormatterFn((function(  ) {
  return function(d) { return "Siirry takaisin"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1492451526 = messageFormatterFn((function(  ) {
  return function(d) { return "Uusi linkki lähetetty."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1194142048 = messageFormatterFn((function(  ) {
  return function(d) { return "Luo tili " + d["0"] + "-sivustolle"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1933352217 = messageFormatterFn((function(  ) {
  return function(d) { return "Luo tili jollakin seuraavista:"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1885297593 = messageFormatterFn((function(  ) {
  return function(d) { return "Luo tili sähköpostiosoitteella"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a595121580 = messageFormatterFn((function(  ) {
  return function(d) { return "Voit myös luoda tilin sähköpostiosoitteella"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1678345244 = messageFormatterFn((function(  ) {
  return function(d) { return "Etu- ja sukunimi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1567137122 = messageFormatterFn((function(  ) {
  return function(d) { return "Suku- ja etunimi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a412197127 = messageFormatterFn((function(  ) {
  return function(d) { return "Oltava 8–30 merkkiä pitkä, ei saa sisältää välilyöntejä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1742944247 = messageFormatterFn((function(  ) {
  return function(d) { return "Luo tili"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1015769850 = messageFormatterFn((function(  ) {
  return function(d) { return "Onko sinulla jo tili?"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a571449082 = messageFormatterFn((function(  ) {
  return function(d) { return "Luomalla tilin hyväksyn " + d["0"] + "n <a href=\"" + d["1"] + "\" target=\"_blank\">käyttöehdot<span class=\"is-visually-hidden\"> Avautuu uuteen ikkunaan</span></a>, <a href=\"" + d["2"] + "\" target=\"_blank\">tietosuojakäytännön<span class=\"is-visually-hidden\"> Avautuu uuteen ikkunaan</span></a> sekä <a href=\"" + d["3"] + "\" target=\"_blank\">" + d["4"] + " -ohjelman ehdot ja rajoitukset<span class=\"is-visually-hidden\"> Avautuu uuteen ikkunaan</span></a>."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a218018529 = messageFormatterFn((function(  ) {
  return function(d) { return "Haluan saada sähköpostitse matka-alennuksia, erikoistarjouksia ja muuta tietoa."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a403310315 = messageFormatterFn((function(  ) {
  return function(d) { return "Lähetimme sinulle sähköpostitse linkin, jonka kautta voit viimeistellä tilin luomisen. "; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2030356650 = messageFormatterFn((function(  ) {
  return function(d) { return "Viimeistele tilisi luominen napsauttamalla linkkiä, jonka lähetimme sähköpostiosoitteeseen " + d["0"] + "."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b627731137 = messageFormatterFn((function(  ) {
  return function(d) { return "Vaihda salasanasi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b193263333 = messageFormatterFn((function(  ) {
  return function(d) { return "Anna sähköpostiosoitteesi ja me lähetämme sinulle linkin, jonka kautta voit vaihtaa salasanasi."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b417881327 = messageFormatterFn((function(  ) {
  return function(d) { return "Lähetä linkki"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1875024673 = messageFormatterFn((function(  ) {
  return function(d) { return "tai maksa vierailevana asiakkaana"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1035730311 = messageFormatterFn((function(  ) {
  return function(d) { return "Valitse uusi salasana"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a502460120 = messageFormatterFn((function(  ) {
  return function(d) { return "Luo uusi salasana"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a654072787 = messageFormatterFn((function(  ) {
  return function(d) { return "Sähköposti: " + d["0"]; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1021252041 = messageFormatterFn((function(  ) {
  return function(d) { return "Tallenna salasana"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1853174597 = messageFormatterFn((function(  ) {
  return function(d) { return "Tämä linkki ei ole enää voimassa"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1333597968 = messageFormatterFn((function(  ) {
  return function(d) { return "Jos haluat vaihtaa salasanasi, pyydä uusi linkki."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1794850768 = messageFormatterFn((function(  ) {
  return function(d) { return "Lähetä uusi linkki"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b347570777 = messageFormatterFn((function(  ) {
  return function(d) { return "Takaisin sisäänkirjautumiseen"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b26745862 = messageFormatterFn((function(  ) {
  return function(d) { return "Lähetimme sinulle sähköpostitse uuden linkin, jonka kautta voit vaihtaa salasanasi."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1132304689 = messageFormatterFn((function(  ) {
  return function(d) { return "Mikä on sähköpostiosoitteesi?"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1805284652 = messageFormatterFn((function(  ) {
  return function(d) { return "Anna sähköpostiosoite, jotta palveluntarjoajat tai " + d["0"] + " voivat ottaa sinuun yhteyttä. Lähetämme sinulle turvakoodin, jonka avulla voimme vahvistaa henkilöllisyytesi."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1894392487 = messageFormatterFn((function(  ) {
  return function(d) { return "Olet luonut " + d["0"] + "-tilisi puhelinnumerolla. Anna sähköpostiosoitteesi, jotta voimme viimeistellä sisäänkirjautumisesi. Lähetämme sinulle turvakoodin, jonka avulla voimme vahvistaa henkilöllisyytesi."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2084008550 = messageFormatterFn((function(  ) {
  return function(d) { return "Lähetä turvakoodi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1636265804 = messageFormatterFn((function(  ) {
  return function(d) { return "Anna turvakoodi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1278178100 = messageFormatterFn((function(  ) {
  return function(d) { return "Anna osoitteeseen " + d["0"] + " lähettämämme turvakoodi."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1049841661 = messageFormatterFn((function(  ) {
  return function(d) { return "Turvakoodi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1706997631 = messageFormatterFn((function(  ) {
  return function(d) { return "Lähetä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a262166837 = messageFormatterFn((function(  ) {
  return function(d) { return "Eikö sähköpostiviesti tullut perille?"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a293300847 = messageFormatterFn((function(  ) {
  return function(d) { return "Lähetä uusi koodi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a890409036 = messageFormatterFn((function(  ) {
  return function(d) { return "Olemme lähettäneet sinulle uuden turvakoodin."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2099327407 = messageFormatterFn((function(  ) {
  return function(d) { return "Anna kelvollinen turvakoodi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2037736522 = messageFormatterFn((function(  ) {
  return function(d) { return "Olet ylittänyt turvakoodin sallittujen lähetysyritysten enimmäismäärän. Yritä uudelleen 24 tunnin kuluttua."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1000717196 = messageFormatterFn((function(  ) {
  return function(d) { return "Olet ylittänyt turvakoodin sallittujen antamisyritysten enimmäismäärän. Yritä uudelleen 24 tunnin kuluttua."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a331991923 = messageFormatterFn((function(  ) {
  return function(d) { return "Anna oikea turvakoodi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a275194377 = messageFormatterFn((function(  ) {
  return function(d) { return "Antamallasi sähköpostiosoitteella on jo luotu " + d["0"] + "-tili " + d["1"] + "-tilin avulla. Yritä kirjautua sisään tähän sähköpostiosoitteeseen liittyvän " + d["1"] + "-tilin avulla."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1517210142 = messageFormatterFn((function(  ) {
  return function(d) { return "Turvallisuussyistä pyydämme sinua vaihtamaan salasanasi ennen sisäänkirjautumista."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1516171060 = messageFormatterFn((function(  ) {
  return function(d) { return "Jos sinulla on " + d["0"] + "-tili, lähetämme sinulle linkin salasanan vaihtamiseen."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a956676191 = messageFormatterFn((function(  ) {
  return function(d) { return "Tervetuloa takaisin, " + d["0"] + "!"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b805137925 = messageFormatterFn((function(  ) {
  return function(d) { return "Uusi salasanasi on tallennettu."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1988533233 = messageFormatterFn((function(  ) {
  return function(d) { return "Takaisin sivustolle"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1653310017 = messageFormatterFn((function(  ) {
  return function(d) { return "Tervetuloa, " + d["0"] + "!"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b355873821 = messageFormatterFn((function(  ) {
  return function(d) { return "Järjestelmässämme tapahtui virhe"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1029553132 = messageFormatterFn((function(  ) {
  return function(d) { return "Korjaa alla olevat " + d["0"] + " virhettä jatkaaksesi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1767485987 = messageFormatterFn((function(  ) {
  return function(d) { return "Syötit tuntemattoman sähköpostiosoitteen tai virheellisen salasanan"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1393992923 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "-yhteyden luominen ei onnistunut"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b6122138 = messageFormatterFn((function(  ) {
  return function(d) { return "Vaihtolinkki on valitettavasti vanhentunut"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1340600576 = messageFormatterFn((function(  ) {
  return function(d) { return "Pyydä uusi linkki"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a433676422 = messageFormatterFn((function(  ) {
  return function(d) { return "Istuntosi on vanhentunut"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1195463122 = messageFormatterFn((function(  ) {
  return function(d) { return "Kirjoita etu- ja sukunimi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1749030886 = messageFormatterFn((function(  ) {
  return function(d) { return "Lisää suku- ja etunimi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a278008040 = messageFormatterFn((function(  ) {
  return function(d) { return "Anna nimi käyttäen vain kirjaimia"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b748351352 = messageFormatterFn((function(  ) {
  return function(d) { return "Tämä osoite on jo rekisteröity toisen " + d["0"] + "-tilin sähköpostiosoitteeksi  "; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b925497604 = messageFormatterFn((function(  ) {
  return function(d) { return "Salasana ei saa sisältää välilyöntejä."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b267820963 = messageFormatterFn((function(  ) {
  return function(d) { return "Salasana ei voi olla sama kuin sähköpostiosoite."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1974029767 = messageFormatterFn((function(  ) {
  return function(d) { return "Tämän salasanan voi arvata helposti."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1857265298 = messageFormatterFn((function(  ) {
  return function(d) { return "Tämä sähköpostiosoite on jo käytössä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b375588449 = messageFormatterFn((function(  ) {
  return function(d) { return "Salasana on pakollinen."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b174024133 = messageFormatterFn((function(  ) {
  return function(d) { return "Salasana on väärin."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1290848649 = messageFormatterFn((function(  ) {
  return function(d) { return "Salasanan on oltava vähintään " + d["0"] + " merkkiä pitkä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a633932599 = messageFormatterFn((function(  ) {
  return function(d) { return "Salasanan on oltava " + d["0"] + "–" + d["1"] + " merkkiä pitkä."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1992662855 = messageFormatterFn((function(  ) {
  return function(d) { return "Tällä sähköpostiosoitteella on jo luotu " + d["0"] + "-tili " + d["1"] + "-tilin kautta. Käytä eri sähköpostiosoitetta tai kirjaudu sisään tähän sähköpostiosoitteeseen liittyvän " + d["1"] + "-tilin kautta"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a133459667 = messageFormatterFn((function(  ) {
  return function(d) { return "Emme valitettavasti voi kirjata sinua sisään Apple ID:si avulla. Teemme töitä voidaksemme tukea niitä Apple ID:itä, jotka ovat puhelinnumeroja. Tällä välin pyydämme sinua kirjautumaan sisään jollain toisella tavalla."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a34125495 = messageFormatterFn((function(  ) {
  return function(d) { return "Emme löydä tätä tiliä."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a47571496 = messageFormatterFn((function(  ) {
  return function(d) { return "Sähköpostiosoite on pakollinen."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1625171705 = messageFormatterFn((function(  ) {
  return function(d) { return "Sulje sisäänkirjautuminen"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a2137957999 = messageFormatterFn((function(  ) {
  return function(d) { return "Sulje tilin luominen"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1700622252 = messageFormatterFn((function(  ) {
  return function(d) { return "Takaisin edelliselle sivulle"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b681689037 = messageFormatterFn((function(  ) {
  return function(d) { return "Sulje sähköpostivahvistuksen ikkuna"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b490527257 = messageFormatterFn((function(  ) {
  return function(d) { return "Sulje turvakoodin lisäysikkuna"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2023260303 = messageFormatterFn((function(  ) {
  return function(d) { return "Maksa vierailevana asiakkaana tai kirjaudu sisään"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1193370641 = messageFormatterFn((function(  ) {
  return function(d) { return "Olen uusi asiakas"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b476759120 = messageFormatterFn((function(  ) {
  return function(d) { return "Voit luoda tilin myös maksamisen jälkeen."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b173124817 = messageFormatterFn((function(  ) {
  return function(d) { return "Maksa vierailevana asiakkaana"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1044286371 = messageFormatterFn((function(  ) {
  return function(d) { return "Olen palaava asiakas"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1014858765 = messageFormatterFn((function(  ) {
  return function(d) { return "Kirjautumalla sisään voit ansaita varauksestasi pisteitä ja käyttää niitä varaukseesi."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1331763460 = messageFormatterFn((function(  ) {
  return function(d) { return "Kirjaudu sisään ja maksa"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a2117170517 = messageFormatterFn((function(  ) {
  return function(d) { return "Tai jatka jollakin seuraavista:"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a477615429 = messageFormatterFn((function(  ) {
  return function(d) { return "Tervetuloa takaisin!"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1979037580 = messageFormatterFn((function(  ) {
  return function(d) { return "Kirjaudu sisään tai luo tili"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1364225855 = messageFormatterFn((function(  ) {
  return function(d) { return "Jatka"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b225772189 = messageFormatterFn((function(  ) {
  return function(d) { return "Lähetimme salasanan vaihtolinkin osoitteeseen " + d["0"] + ". Viestin saapumiseen voi mennä muutama minuutti. Tarkista roskapostikansiosi, jollet löydä lähettämäämme viestiä saapuneiden viestiesi joukosta."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b850945850 = messageFormatterFn((function(  ) {
  return function(d) { return "Vaihda salasana"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a896122718 = messageFormatterFn((function(  ) {
  return function(d) { return "Salasanassasi tulee olla vähintään 8 merkkiä."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1479398104 = messageFormatterFn((function(  ) {
  return function(d) { return "Jatka käyttämällä linkitettyä tiliä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1232952958 = messageFormatterFn((function(  ) {
  return function(d) { return "tai luo salasana"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b150970552 = messageFormatterFn((function(  ) {
  return function(d) { return "Tarkista sähköpostisi!"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b901718769 = messageFormatterFn((function(  ) {
  return function(d) { return "Lähetimme vahvistuslinkin osoitteeseen " + d["0"] + ", jotta voit luoda tilillesi salasanan. Viestin saapumiseen voi mennä muutama minuutti. Tarkista roskapostikansiosi, jollet löydä lähettämäämme viestiä saapuneiden viestiesi joukosta."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b73072493 = messageFormatterFn((function(  ) {
  return function(d) { return "Luo salasana"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1006746217 = messageFormatterFn((function(  ) {
  return function(d) { return "Muokkaa"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1612532181 = messageFormatterFn((function(  ) {
  return function(d) { return "Vaikuttaa siltä, että olet varannut kauttamme ennenkin. Turvallisuussyiden vuoksi meidän tulee vahvistaa sähköpostiosoitteesi."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a698998263 = messageFormatterFn((function(  ) {
  return function(d) { return "Viimeistele tilisi luominen osoitteeseen " + d["0"] + " lähettämämme vahvistuslinkin avulla. Viestin saapumiseen voi mennä muutama minuutti. Tarkista roskapostikansiosi, jollet löydä lähettämäämme viestiä saapuneiden viestiesi joukosta."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a267617177 = messageFormatterFn((function(  ) {
  return function(d) { return "Omat matkatiedot"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a610759436 = messageFormatterFn((function(  ) {
  return function(d) { return "Tilitiedot"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b93643698 = messageFormatterFn((function(  ) {
  return function(d) { return "Päivitä henkilötiedot ja muokkaa valintoja"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1978702776 = messageFormatterFn((function(  ) {
  return function(d) { return "TSA-tiedot"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b2092771748 = messageFormatterFn((function(  ) {
  return function(d) { return "Lisää Known Traveler- tai redress-numero"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b499995306 = messageFormatterFn((function(  ) {
  return function(d) { return "Henkilötiedot"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a436861562 = messageFormatterFn((function(  ) {
  return function(d) { return "Anna perus- ja yhteystiedot"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1628446319 = messageFormatterFn((function(  ) {
  return function(d) { return "Lentovalinnat"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1819582219 = messageFormatterFn((function(  ) {
  return function(d) { return "Muokkaa kokemustasi säätämällä asetuksia"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1224478944 = messageFormatterFn((function(  ) {
  return function(d) { return "Kanta-asiakasohjelmat"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a234617220 = messageFormatterFn((function(  ) {
  return function(d) { return "Tallenna kanta-asiakas- ja jäsentietosi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1915598126 = messageFormatterFn((function(  ) {
  return function(d) { return "Passi"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1800400118 = messageFormatterFn((function(  ) {
  return function(d) { return "Nopeuta varausprosessia tallentamalla passisi tiedot."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1248616395 = messageFormatterFn((function(  ) {
  return function(d) { return "Laitteiden hallinta"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1607655087 = messageFormatterFn((function(  ) {
  return function(d) { return "Tarkista sisäänkirjautuneet laitteet"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1079456073 = messageFormatterFn((function(  ) {
  return function(d) { return "Avaa tilisi kirjautumalla sisään"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1570912122 = messageFormatterFn((function(  ) {
  return function(d) { return "Luo tili"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1797265273 = messageFormatterFn((function(  ) {
  return function(d) { return "Järjestelmässämme ilmeni valitettavasti ongelmia."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b1343087630 = messageFormatterFn((function(  ) {
  return function(d) { return "Näyttää siltä, että internetyhteytesi on katkennut. Tarkista yhteytesi ja yritä uudelleen."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a223857324 = messageFormatterFn((function(  ) {
  return function(d) { return "Yritä uudelleen"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.b686893795 = messageFormatterFn((function(  ) {
  return function(d) { return "Ladataan..."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a679610818 = messageFormatterFn((function(  ) {
  return function(d) { return "1 yö"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a623908298 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " yötä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a278913718 = messageFormatterFn((function(  ) {
  return function(d) { return "Valmis, 1 yö valittu. Tallenna muutokset ja sulje kalenteri."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a2035913534 = messageFormatterFn((function(  ) {
  return function(d) { return "Valmis, " + d["0"] + " yötä valittu. Tallenna muutokset ja sulje kalenteri."; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a210854203 = messageFormatterFn((function(  ) {
  return function(d) { return "Päivä"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a1557675748 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " tulosta saatavana"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a242594140 = messageFormatterFn((function(  ) {
  return function(d) { return "1 tulos saatavana"; }
})(), Globalize("fi-FI").pluralGenerator({}));
Globalize.a937258072 = dateToPartsFormatterFn({"2":Globalize("fi-FI").numberFormatter({"raw":"00"}),"4":Globalize("fi-FI").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":"."});
Globalize.b177288296 = dateToPartsFormatterFn({"2":Globalize("fi-FI").numberFormatter({"raw":"00"}),"4":Globalize("fi-FI").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":"."});
Globalize.a400801259 = dateToPartsFormatterFn({"1":Globalize("fi-FI").numberFormatter({"raw":"0"}),"4":Globalize("fi-FI").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":"."});
Globalize.b721652699 = dateToPartsFormatterFn({"1":Globalize("fi-FI").numberFormatter({"raw":"0"}),"4":Globalize("fi-FI").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":"."});
Globalize.b123147272 = dateToPartsFormatterFn({"2":Globalize("fi-FI").numberFormatter({"raw":"00"}),"4":Globalize("fi-FI").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":"."});
Globalize.b1145495571 = dateToPartsFormatterFn({"1":Globalize("fi-FI").numberFormatter({"raw":"0"}),"4":Globalize("fi-FI").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":"."});
Globalize.a1674574744 = dateToPartsFormatterFn({"2":Globalize("fi-FI").numberFormatter({"raw":"00"}),"4":Globalize("fi-FI").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":"."});
Globalize.b69006248 = dateToPartsFormatterFn({"2":Globalize("fi-FI").numberFormatter({"raw":"00"}),"4":Globalize("fi-FI").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":"."});
Globalize.a460488024 = dateToPartsFormatterFn({"2":Globalize("fi-FI").numberFormatter({"raw":"00"}),"4":Globalize("fi-FI").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":"."});
Globalize.a159229867 = dateToPartsFormatterFn({"1":Globalize("fi-FI").numberFormatter({"raw":"0"}),"4":Globalize("fi-FI").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":"."});
Globalize.b841567240 = dateToPartsFormatterFn({"2":Globalize("fi-FI").numberFormatter({"raw":"00"}),"4":Globalize("fi-FI").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":"."});
Globalize.b786010873 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":".","days":{"E":{"5":{"sun":"S","mon":"M","tue":"T","wed":"K","thu":"T","fri":"P","sat":"L"}}}});
Globalize.b1687954024 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":".","days":{"E":{"4":{"sun":"sunnuntaina","mon":"maanantaina","tue":"tiistaina","wed":"keskiviikkona","thu":"torstaina","fri":"perjantaina","sat":"lauantaina"}}}});
Globalize.a1353767832 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":".","months":{"M":{"4":{"1":"tammikuuta","2":"helmikuuta","3":"maaliskuuta","4":"huhtikuuta","5":"toukokuuta","6":"kesäkuuta","7":"heinäkuuta","8":"elokuuta","9":"syyskuuta","10":"lokakuuta","11":"marraskuuta","12":"joulukuuta"}}}});
Globalize.a1562628168 = dateToPartsFormatterFn({"1":Globalize("fi-FI").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":"."});
Globalize.a1305108747 = dateToPartsFormatterFn({"1":Globalize("fi-FI").numberFormatter({"raw":"0"}),"2":Globalize("fi-FI").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":"."});
Globalize.b533432874 = dateToPartsFormatterFn({"1":Globalize("fi-FI").numberFormatter({"raw":"0"})}, {"pattern":"d. MMM","timeSeparator":".","months":{"M":{"3":{"1":"tammik.","2":"helmik.","3":"maalisk.","4":"huhtik.","5":"toukok.","6":"kesäk.","7":"heinäk.","8":"elok.","9":"syysk.","10":"lokak.","11":"marrask.","12":"jouluk."}}}});
Globalize.a624088947 = dateToPartsFormatterFn({"1":Globalize("fi-FI").numberFormatter({"raw":"0"})}, {"pattern":"d. MMMM","timeSeparator":".","months":{"M":{"4":{"1":"tammikuuta","2":"helmikuuta","3":"maaliskuuta","4":"huhtikuuta","5":"toukokuuta","6":"kesäkuuta","7":"heinäkuuta","8":"elokuuta","9":"syyskuuta","10":"lokakuuta","11":"marraskuuta","12":"joulukuuta"}}}});
Globalize.b71058014 = dateToPartsFormatterFn({"1":Globalize("fi-FI").numberFormatter({"raw":"0"})}, {"pattern":"d. MMMM y","timeSeparator":".","months":{"M":{"4":{"1":"tammikuuta","2":"helmikuuta","3":"maaliskuuta","4":"huhtikuuta","5":"toukokuuta","6":"kesäkuuta","7":"heinäkuuta","8":"elokuuta","9":"syyskuuta","10":"lokakuuta","11":"marraskuuta","12":"joulukuuta"}}}});
Globalize.b2352834 = dateToPartsFormatterFn({"1":Globalize("fi-FI").numberFormatter({"raw":"0"})}, {"pattern":"LLLL y","timeSeparator":".","months":{"L":{"4":{"1":"tammikuu","2":"helmikuu","3":"maaliskuu","4":"huhtikuu","5":"toukokuu","6":"kesäkuu","7":"heinäkuu","8":"elokuu","9":"syyskuu","10":"lokakuu","11":"marraskuu","12":"joulukuu"}}}});
Globalize.b1667641 = dateToPartsFormatterFn({"1":Globalize("fi-FI").numberFormatter({"raw":"0"})}, {"pattern":"d. MMM y","timeSeparator":".","months":{"M":{"3":{"1":"tammik.","2":"helmik.","3":"maalisk.","4":"huhtik.","5":"toukok.","6":"kesäk.","7":"heinäk.","8":"elok.","9":"syysk.","10":"lokak.","11":"marrask.","12":"jouluk."}}}});
Globalize.a1765520150 = dateToPartsFormatterFn({"1":Globalize("fi-FI").numberFormatter({"raw":"0"})}, {"pattern":"cccc d. MMM","timeSeparator":".","days":{"c":{"4":{"sun":"sunnuntai","mon":"maanantai","tue":"tiistai","wed":"keskiviikko","thu":"torstai","fri":"perjantai","sat":"lauantai"}}},"months":{"M":{"3":{"1":"tammik.","2":"helmik.","3":"maalisk.","4":"huhtik.","5":"toukok.","6":"kesäk.","7":"heinäk.","8":"elok.","9":"syysk.","10":"lokak.","11":"marrask.","12":"jouluk."}}}});
Globalize.a616700779 = dateToPartsFormatterFn({"1":Globalize("fi-FI").numberFormatter({"raw":"0"})}, {"pattern":"ccc d. MMM","timeSeparator":".","days":{"c":{"3":{"sun":"su","mon":"ma","tue":"ti","wed":"ke","thu":"to","fri":"pe","sat":"la"}}},"months":{"M":{"3":{"1":"tammik.","2":"helmik.","3":"maalisk.","4":"huhtik.","5":"toukok.","6":"kesäk.","7":"heinäk.","8":"elok.","9":"syysk.","10":"lokak.","11":"marrask.","12":"jouluk."}}}});
Globalize.a1315971823 = dateFormatterFn(Globalize("fi-FI").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.a201425455 = dateFormatterFn(Globalize("fi-FI").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.b2079248830 = dateFormatterFn(Globalize("fi-FI").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.a1093264508 = dateFormatterFn(Globalize("fi-FI").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.a255566479 = dateFormatterFn(Globalize("fi-FI").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.a669421636 = dateFormatterFn(Globalize("fi-FI").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a2053288495 = dateFormatterFn(Globalize("fi-FI").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.a309707503 = dateFormatterFn(Globalize("fi-FI").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.a839201775 = dateFormatterFn(Globalize("fi-FI").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.a1974147074 = dateFormatterFn(Globalize("fi-FI").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.b462853489 = dateFormatterFn(Globalize("fi-FI").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b937184240 = dateFormatterFn(Globalize("fi-FI").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.a1770852719 = dateFormatterFn(Globalize("fi-FI").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.a517607279 = dateFormatterFn(Globalize("fi-FI").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.a2145911761 = dateFormatterFn(Globalize("fi-FI").dateToPartsFormatter({"raw":"d"}));
Globalize.a913701666 = dateFormatterFn(Globalize("fi-FI").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.b105574305 = dateFormatterFn(Globalize("fi-FI").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.a1002802698 = dateFormatterFn(Globalize("fi-FI").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.b1215833621 = dateFormatterFn(Globalize("fi-FI").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.a376360917 = dateFormatterFn(Globalize("fi-FI").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.a377046110 = dateFormatterFn(Globalize("fi-FI").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.a1147789599 = dateFormatterFn(Globalize("fi-FI").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.a995414530 = dateFormatterFn(Globalize("fi-FI").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.b1364933730 = dateParserFn(Globalize("fi-FI").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.a1815487198 = dateParserFn(Globalize("fi-FI").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.a1426337457 = dateParserFn(Globalize("fi-FI").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.a303883499 = dateParserFn(Globalize("fi-FI").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.a1869628222 = dateParserFn(Globalize("fi-FI").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.b119959373 = dateParserFn(Globalize("fi-FI").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.b627617058 = dateParserFn(Globalize("fi-FI").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.a1923769246 = dateParserFn(Globalize("fi-FI").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.b1841703778 = dateParserFn(Globalize("fi-FI").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.a1184766065 = dateParserFn(Globalize("fi-FI").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.a1151208254 = dateParserFn(Globalize("fi-FI").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a868950529 = dateParserFn(Globalize("fi-FI").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^S/],["mon",/^M/],["tue",/^T/],["wed",/^K/],["thu",/^T/],["fri",/^P/],["sat",/^L/]]});
Globalize.a859283806 = dateParserFn(Globalize("fi-FI").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["wed",/^keskiviikkona/],["sun",/^sunnuntaina/],["mon",/^maanantaina/],["fri",/^perjantaina/],["sat",/^lauantaina/],["tue",/^tiistaina/],["thu",/^torstaina/]]});
Globalize.b393961634 = dateParserFn(Globalize("fi-FI").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["3",/^maaliskuuta/],["11",/^marraskuuta/],["1",/^tammikuuta/],["2",/^helmikuuta/],["4",/^huhtikuuta/],["5",/^toukokuuta/],["7",/^heinäkuuta/],["12",/^joulukuuta/],["6",/^kesäkuuta/],["9",/^syyskuuta/],["10",/^lokakuuta/],["8",/^elokuuta/]]});
Globalize.a588124738 = dateParserFn(Globalize("fi-FI").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.a1069304657 = dateParserFn(Globalize("fi-FI").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.a1193418192 = dateParserFn(Globalize("fi-FI").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["3",/^maalisk\./],["11",/^marrask\./],["1",/^tammik\./],["2",/^helmik\./],["4",/^huhtik\./],["5",/^toukok\./],["7",/^heinäk\./],["12",/^jouluk\./],["6",/^kesäk\./],["9",/^syysk\./],["10",/^lokak\./],["8",/^elok\./]]});
Globalize.b1678102855 = dateParserFn(Globalize("fi-FI").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["3",/^maaliskuuta/],["11",/^marraskuuta/],["1",/^tammikuuta/],["2",/^helmikuuta/],["4",/^huhtikuuta/],["5",/^toukokuuta/],["7",/^heinäkuuta/],["12",/^joulukuuta/],["6",/^kesäkuuta/],["9",/^syyskuuta/],["10",/^lokakuuta/],["8",/^elokuuta/]]});
Globalize.a1575440156 = dateParserFn(Globalize("fi-FI").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["3",/^maaliskuuta/],["11",/^marraskuuta/],["1",/^tammikuuta/],["2",/^helmikuuta/],["4",/^huhtikuuta/],["5",/^toukokuuta/],["7",/^heinäkuuta/],["12",/^joulukuuta/],["6",/^kesäkuuta/],["9",/^syyskuuta/],["10",/^lokakuuta/],["8",/^elokuuta/]]});
Globalize.a1990422660 = dateParserFn(Globalize("fi-FI").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"LLLL y","digitsRe":/\d/,"gregorian/months/stand-alone/wide":[["3",/^maaliskuu/],["11",/^marraskuu/],["1",/^tammikuu/],["2",/^helmikuu/],["4",/^huhtikuu/],["5",/^toukokuu/],["7",/^heinäkuu/],["12",/^joulukuu/],["6",/^kesäkuu/],["9",/^syyskuu/],["10",/^lokakuu/],["8",/^elokuu/]]});
Globalize.a1991107853 = dateParserFn(Globalize("fi-FI").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["3",/^maalisk\./],["11",/^marrask\./],["1",/^tammik\./],["2",/^helmik\./],["4",/^huhtik\./],["5",/^toukok\./],["7",/^heinäk\./],["12",/^jouluk\./],["6",/^kesäk\./],["9",/^syysk\./],["10",/^lokak\./],["8",/^elok\./]]});
Globalize.b792670704 = dateParserFn(Globalize("fi-FI").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"cccc d. MMM","digitsRe":/\d/,"gregorian/days/stand-alone/wide":[["wed",/^keskiviikko/],["sun",/^sunnuntai/],["mon",/^maanantai/],["fri",/^perjantai/],["sat",/^lauantai/],["tue",/^tiistai/],["thu",/^torstai/]],"gregorian/months/format/abbreviated":[["3",/^maalisk\./],["11",/^marrask\./],["1",/^tammik\./],["2",/^helmik\./],["4",/^huhtik\./],["5",/^toukok\./],["7",/^heinäk\./],["12",/^jouluk\./],["6",/^kesäk\./],["9",/^syysk\./],["10",/^lokak\./],["8",/^elok\./]]});
Globalize.b1685491023 = dateParserFn(Globalize("fi-FI").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"ccc d. MMM","digitsRe":/\d/,"gregorian/days/stand-alone/abbreviated":[["sun",/^su/],["mon",/^ma/],["tue",/^ti/],["wed",/^ke/],["thu",/^to/],["fri",/^pe/],["sat",/^la/]],"gregorian/months/format/abbreviated":[["3",/^maalisk\./],["11",/^marrask\./],["1",/^tammik\./],["2",/^helmik\./],["4",/^huhtik\./],["5",/^toukok\./],["7",/^heinäk\./],["12",/^jouluk\./],["6",/^kesäk\./],["9",/^syysk\./],["10",/^lokak\./],["8",/^elok\./]]});
module.exports = Globalize;
